import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgFlashDrive = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-flash-drive';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M13.94 3.6 12.3 5.24h-1.8L6.37 9.37 2.24 13.5v2.4l2.93 2.93 2.93 2.93h2.387l4.157-4.127 4.156-4.128V11.66l1.63-1.63 1.63-1.63-3.22-3.22a373 373 0 0 0-3.24-3.22c-.011 0-.758.738-1.66 1.64m3.84 2.64 2.16 2.16-.96.96-.96.96-2.17-2.17-2.17-2.17.95-.95c.522-.522.959-.95.97-.95s.992.972 2.18 2.16m-2.99 2.97 2.49 2.49v1.202l-3.697 3.669-3.696 3.669H8.7l-2.47-2.47-2.47-2.47v-1.2l3.67-3.669 3.67-3.669.52-.012c.286-.007.556-.017.6-.021.058-.007.771.682 2.57 2.481m-8.5 6.08-.53.531 1.2 1.199 1.2 1.2.53-.53.53-.53-1.2-1.2-1.201-1.2z"
    })
  }));
});
export default SvgFlashDrive;